<template>
  <v-list-tile :key="score.id" avatar @click="$emit('go-to-game')">
    <v-list-tile-avatar class="mt-0" :tile="true" size="86">
      <v-img :src="score.cover" :aspect-ratio="2.75"></v-img>
    </v-list-tile-avatar>

    <v-list-tile-content class="ml-3">
      <v-list-tile-title class="text-truncate">{{ score.title }}</v-list-tile-title>
      <v-list-tile-sub-title class="text-truncate"
        >{{ score.platform }} {{ score.mode }} {{ score.difficulty }}
        <div style="float: right">{{ score.ratio | formatPercent }}</div>
      </v-list-tile-sub-title>
      <v-list-tile-sub-title>{{ score.score | formatNumber }} pts</v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>
<script>
export default {
  props: ['score'],
};
</script>
